/** Страница регистрации: создаёт аккаунт и сохраняет выданный токен. */
import { useForm } from "@tanstack/react-form";
import { Link, useNavigate } from "react-router-dom";
import { z } from "zod";
import { apiHooks } from "@/api";
import { routerPaths } from "@/app/routerPaths";
import { UIKit } from "@/shared/ui";

const registerSchema = z.object({
	email: z
		.string()
		.min(1, "Введите электронную почту")
		.email("Введите корректную электронную почту"),
	name: z.string().min(1, "Введите имя"),
	password: z.string().min(8, "Пароль должен содержать минимум 8 символов"),
});

export const RegisterPage = () => {
	const navigate = useNavigate();
	const registerApi = apiHooks.auth.useRegister();
	const form = useForm({
		defaultValues: { email: "", name: "", password: "" },
		validators: { onChange: registerSchema },
		onSubmit: async ({ value }) => {
			const response = await registerApi.execute({ ...value, name: value.name || null });
			if (response.error !== null) return;
			await navigate(routerPaths.planner);
		},
	});

	return (
		<div className="flex flex-1 items-center justify-center overflow-y-auto px-5 py-10">
			<form className="w-full max-w-sm" action={() => form.handleSubmit()}>
				<UIKit.Text className="mb-2 font-medium text-accent">GRID PLANNER</UIKit.Text>
				<UIKit.Text size="xl">Создать аккаунт</UIKit.Text>
				<UIKit.Text className="mt-2 text-ink">
					Сохраняйте проекты и возвращайтесь к ним с любого устройства.
				</UIKit.Text>
				<div className="mt-7 space-y-4">
					<UIKit.FormField form={form} name="name">
						{(field) => (
							<UIKit.TextInput
								label="Имя"
								name={field.name}
								value={field.state.value}
								onChange={field.handleChange}
								autoComplete="name"
							/>
						)}
					</UIKit.FormField>
					<UIKit.FormField form={form} name="email">
						{(field) => (
							<UIKit.TextInput
								label="Электронная почта"
								type="email"
								value={field.state.value}
								onChange={field.handleChange}
								autoComplete="email"
							/>
						)}
					</UIKit.FormField>
					<UIKit.FormField form={form} name="password">
						{(field) => (
							<UIKit.TextInput
								label="Пароль"
								type="password"
								value={field.state.value}
								onChange={field.handleChange}
								autoComplete="new-password"
							/>
						)}
					</UIKit.FormField>
				</div>
				<UIKit.Button
					className="mt-6 w-full border-accent bg-accent py-3 text-sm font-medium text-overlay-ink hover:border-accent-hover hover:bg-accent-hover"
					type="submit"
					disabled={registerApi.isPending}
				>
					{registerApi.isPending ? "Создаём..." : "Создать аккаунт"}
				</UIKit.Button>
				<UIKit.Text className="mt-5 text-center text-ink">
					Уже есть аккаунт?{" "}
					<Link className="font-medium text-accent hover:underline" to={routerPaths.login}>
						Войти
					</Link>
				</UIKit.Text>
				<UIKit.Text className="mt-3 text-center text-ink">
					<Link className="font-medium text-accent hover:underline" to={routerPaths.emailConfirm}>
						Подтвердить e-mail
					</Link>
				</UIKit.Text>
			</form>
		</div>
	);
};
